// Lazy ulid — good enough for client-generated IDs. The handler upserts
// regardless of id format, and the schedules container is keyed by /deviceId
// so id collisions only matter per-device. Don't want a 60kB dep for this.

export function ulid(): string {
  const time = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 12);
  return `${time}${rand}`;
}
